import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import TheoryTypeSelector from './theory-type-selector';
import GuideType from './guide-type';
import DefinitionType from './definition-type';
import AnimationType from './animation-type';
import VideoType from './video-type';

const types = {
    GUIDE: { id: 16, title: 'Esercizi guida' },
    ANIMATION: { id: 13, title: 'Animazioni' },
    VIDEO: { id: 11, title: 'Video' },
    DEFINITION: { id: 17, title: 'Definizioni' },
};

const ContentContainer = styled.div`
    padding-top: 24px;
`;

const TheoryList = ({ microThemeId, theories }) => {
    const [selectedType, setSelectedType] = useState();
    const [availableTheories] = useState(() => {
        return Object.keys(types)
            .map((key) => {
                const filteredTheory = theories.filter((theory) => theory.contentType === types[key].id);

                return {
                    type: key,
                    count: filteredTheory.length,
                    title: `${types[key].title} (${filteredTheory.length})`,
                };
            })
            .filter((item) => item.count > 0);
    });

    const currentType = selectedType || availableTheories[0].type;

    return (
        <div>
            <TheoryTypeSelector
                microThemeId={microThemeId}
                availableTheories={availableTheories}
                onChange={(type) => setSelectedType(type)}
                selectedType={selectedType || availableTheories[0].type}
            />
            <ContentContainer>
                {currentType === 'GUIDE' && <GuideType guides={theories.filter((t) => t.contentType === types['GUIDE'].id)} />}
                {currentType === 'DEFINITION' && (
                    <DefinitionType definitions={theories.filter((t) => t.contentType === types['DEFINITION'].id)} />
                )}
                {currentType === 'ANIMATION' && (
                    <AnimationType animations={theories.filter((t) => t.contentType === types['ANIMATION'].id)} />
                )}
                {currentType === 'VIDEO' && <VideoType videos={theories.filter((t) => t.contentType === types['VIDEO'].id)} />}
            </ContentContainer>
        </div>
    );
};

TheoryList.propTypes = {
    microThemeId: PropTypes.string,
    theories: PropTypes.array,
};

export default TheoryList;
